<template>
  <div>
    <base-crud
      crudName="Solicitações de vale-transporte"
      newText="Nova Solicitação"
      :table="transportSolicitationsTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :dataForm="dataForm"
      :toadd="'transportationRequest'"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

function format(datetime) {
  return moment(datetime).format("DD/MM/YYYY");
}

export default {
  data: function() {
    return {
      transportSolicitationsTable: "transportSolicitationsTable",
      columns: [
        "id",
        "date",
        "transport_value",
        "user_id",
        "approver_id",
        "status_id"
      ],
      tableData: [
        "id",
        "date",
        "transport_value",
        "user_id",
        "approver_id",
        "status_id"
      ],
      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "date",
          "transport_value",
          "user_id",
          "approver_id",
          "status_id"
        ],
        sortable: [
          "id",
          "date",
          "transport_value",
          "user_id",
          "approver_id",
          "status_id"
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          date: "Data",
          transport_value: "Valor",
          user_id: "Usuário",
          approver_id: "Aprovador",
          status_id: "Status"
        },
        requestFunction: function(data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "approver", "status"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        templates: {
          date: function(h, row, index) {
            return format(row.date);
          },
          user_id: function(h, row, index) {
            return row.user.name;
          },
          transport_value: function(h, row, index) {
            var formatter = new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL"
            });
            return (
              formatter.format(row.transport_value)
            )
          },
          approver_id: function(h, row, index) {
            return row.approver ? row.approver.name : "";
          },
          status_id: function(h, row, index) {
            return row.status.name;
          }
        }
      },
      endPoint: "transport_solicitations/",

      dataForm: {}
    };
  },
  components: {
    BaseCrud
  },
  methods: {
    query: function(query) {
      let columns = {
        id: "id",
        date: "date",
        user_id: "user_id",
        approver_id: "approver_id",
        status_id: "status_id"
      };
      let filters = "orderByDesc=id&";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TransportationRequest/Crud.vue